import {useMutation} from '@apollo/react-hooks';

import type {
    RemoveExternalMeeting as RemoveExternalMeetingMutation,
    RemoveExternalMeetingVariables as RemoveExternalMeetingMutationVariables,
    GetExternalMeetings as GetExternalMeetingsQuery,
} from 'nutshell-graphql-types';

import REMOVE_EXTERNAL_MEETING from '../mutations/remove-external-meeting.graphql';
import GET_EXTERNAL_MEETINGS from '../queries/get-external-meetings.graphql';

import {MEETINGS_LIMIT} from '.';

export function useRemoveExternalMeeting(): (id: string) => Promise<any> {
    const [removeExternalMeeting] = useMutation<
        RemoveExternalMeetingMutation,
        RemoveExternalMeetingMutationVariables
    >(REMOVE_EXTERNAL_MEETING);

    return (id: string) =>
        removeExternalMeeting({
            variables: {input: {id}},
            refetchQueries: ['GetExternalMeetings', 'GetMeetingsSidebarCounts'],
            update: (proxy, mutationResult) => {
                const removedExternalMeeting =
                    mutationResult &&
                    mutationResult.data &&
                    mutationResult.data.removeExternalMeeting &&
                    mutationResult.data.removeExternalMeeting.externalMeeting;
                if (!removedExternalMeeting) {
                    return;
                }

                // Remove newly logged meeting from unlogged meetings table
                const unloggedCacheResult: GetExternalMeetingsQuery | null | undefined =
                    proxy.readQuery({
                        query: GET_EXTERNAL_MEETINGS,
                        variables: {isLogged: false, first: MEETINGS_LIMIT},
                    });
                if (!unloggedCacheResult) {
                    return;
                }

                const existingUnloggedZoomMeetings = unloggedCacheResult.externalMeetings;
                proxy.writeQuery({
                    query: GET_EXTERNAL_MEETINGS,
                    variables: {isLogged: false, first: MEETINGS_LIMIT},
                    data: {
                        externalMeetings: {
                            __typename: 'ExternalMeetingsConnection',
                            edges: existingUnloggedZoomMeetings.edges.filter(
                                (edge) => edge.node.id !== removedExternalMeeting.id
                            ),
                            count: existingUnloggedZoomMeetings.count - 1,
                        },
                    },
                });
            },
        });
}
